import { Card, CardTitle } from 'src/shared/components/ui'
import { CardContent } from 'src/shared/components/ui/card'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/shared/components/ui/select'
import { Column } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

interface LocalizationRegionProps {
  timezone: string
  currency: string
  language: string
  onTimezoneChange: (value: string) => void
  onCurrencyChange: (value: string) => void
  onLanguageChange: (value: string) => void
}

export const LocalizationRegion = ({
  timezone,
  currency,
  language,
  onTimezoneChange,
  onCurrencyChange,
  onLanguageChange,
}: LocalizationRegionProps) => {
  const { t } = useLocalization()

  // Timezone options
  // const timezones = [
  //   { value: 'America/New_York', label: '(GMT-05:00) Eastern Time' },
  //   { value: 'America/Chicago', label: '(GMT-06:00) Central Time' },
  //   { value: 'America/Denver', label: '(GMT-07:00) Mountain Time' },
  //   { value: 'America/Los_Angeles', label: '(GMT-08:00) Pacific Time' },
  //   { value: 'Europe/London', label: '(GMT+00:00) Greenwich Mean Time' },
  //   { value: 'Europe/Paris', label: '(GMT+01:00) Central European Time' },
  // ]

  // Currency options
  const currencies = [
    { value: 'SEK', label: 'SEK (kr)' },
    { value: 'EUR', label: 'EUR (€)' },
  ]

  // Language options
  const languages = [
    { value: 'sv-SE', label: 'Swedish (SE)' },
    { value: 'en-US', label: 'English (US)' },
  ]

  return (
    <Card>
      <CardContent className="p-6">
        <Column className="gap-6">
          <CardTitle className="text-lg">
            {t('Localization and region', 'Lokalisering och region')}
          </CardTitle>

          {/* Time Zone */}
          {/* <Column className="gap-2">
            <label className="text-sm font-medium text-foreground">
              {t('Time Zone', 'Tidszon')}
            </label>
            <Select value={timezone} onValueChange={onTimezoneChange}>
              <SelectTrigger className="w-full">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {timezones.map((tz) => (
                  <SelectItem key={tz.value} value={tz.value}>
                    {tz.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </Column> */}

          <Select
            label={t('Default currency', 'Standardvaluta')}
            value={currency}
            onValueChange={onCurrencyChange}
          >
            <SelectTrigger className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {currencies.map((curr) => (
                <SelectItem key={curr.value} value={curr.value}>
                  {curr.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select
            label={t('Language', 'Språk')}
            value={language}
            onValueChange={onLanguageChange}
          >
            <SelectTrigger className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {languages.map((lang) => (
                <SelectItem key={lang.value} value={lang.value}>
                  {lang.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Column>
      </CardContent>
    </Card>
  )
}
